import React from 'react';
import { NavLink } from 'react-router-dom';
import { FileText, Users } from 'lucide-react';
import { ADMIN_USERS } from '@/constants/testIds';

const linkClass = ({ isActive }) =>
  `inline-flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-[0.2em] rounded-md transition-colors ${
    isActive
      ? 'bg-[#0A2540] text-white'
      : 'text-slate-500 hover:text-[#0A2540] hover:bg-slate-100'
  }`;

export function AdminNav() {
  return (
    <nav className="flex items-center gap-1 bg-white border border-slate-200 rounded-md p-1">
      <NavLink to="/admin" end className={linkClass} data-testid={ADMIN_USERS.documentsLink}>
        <FileText className="h-3.5 w-3.5" />
        Documents
      </NavLink>
      <NavLink to="/admin/users" className={linkClass} data-testid={ADMIN_USERS.usersLink}>
        <Users className="h-3.5 w-3.5" />
        Users
      </NavLink>
    </nav>
  );
}
